import { StringIndexedObject } from "@kanda-libs/ks-design-library";
import { UserType } from "@kanda-libs/ks-frontend-services";

export const formatDefaultValues = (user?: UserType): StringIndexedObject => {
  if (!user) return {};
  return {
    ...user,
    director_info: {
      ...user.director_info,
      date_of_birth: (user.director_info?.date_of_birth || "")
        .split("-")
        .reverse()
        .join("/"),
    },
  };
};

export const formatDirectorAddress = (
  address: StringIndexedObject
): StringIndexedObject => {
  const { country, county, months_at_address } = address;
  const finalAddress: StringIndexedObject = {
    country,
    county,
    months_at_address,
  };

  if (address.building_name) {
    finalAddress.building_name = address.building_name;
  }

  if (address.building_number) {
    finalAddress.building_number = address.building_number;
  }

  if (address.line_1) {
    finalAddress.line_1 = address.line_1;
  }

  if (address.line_2) {
    finalAddress.line_2 = address.line_2;
  }

  if (address.city) {
    finalAddress.city = address.city;
  }

  if (address.postcode) {
    finalAddress.postcode = address.postcode;
  }

  return finalAddress;
};
